(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vormann-refined"] && !Shopify.designMode) return;
  try {
    (() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const seen = new WeakSet();
    const running = new Set();
    const selectors = [
      '#vormann-productos h2',
      '#vormann-productos [class*="ai-premium-product-image-wrapper-"]',
      '[id$="__product_list_UwRqN4"] h2',
      '[id$="__product_list_UwRqN4"] .card-gallery',
      '.vr-faq__intro h2'
    ].join(',');
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        if (preference.matches || !entry.target.animate) continue;
        const animation = entry.target.animate([
          { opacity: .08, transform: 'translateY(36px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 1250, easing: 'cubic-bezier(.16,.65,.25,1)' });
        running.add(animation);
        animation.finished.then(() => running.delete(animation), () => running.delete(animation));
      }
    }, { threshold: .16 }) : null;
    function prepare(root = document) {
      if (!observer) return;
      for (const element of root.querySelectorAll(selectors)) {
        if (seen.has(element)) continue;
        seen.add(element);
        if (preference.matches || element.getBoundingClientRect().top < window.innerHeight) continue;
        observer.observe(element);
      }
    }
    preference.addEventListener('change', () => {
      if (!preference.matches) return;
      observer?.disconnect();
      for (const animation of running) animation.cancel();
      running.clear();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
    else prepare();
    document.addEventListener('shopify:section:load', event => prepare(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
